import React, { useState, useEffect } from 'react';
import { apiRequest } from '../utils/api';

const EditVPS = ({ vps, onUpdate, onCancel }) => {
  const [formData, setFormData] = useState({
    ip: '',
    user: '',
    password: '',
    provider: '',
    providerUser: '',
    providerPassword: '',
    startDate: '',
    endDate: '',
    port: '22',
    notes: '',
    isActive: true,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    if (vps) {
      setFormData({
        ip: vps.ip || '',
        user: vps.user || '',
        password: vps.password || '',
        provider: vps.provider || '',
        providerUser: vps.providerUser || '',
        providerPassword: vps.providerPassword || '',
        startDate: vps.startDate ? new Date(vps.startDate).toISOString().split('T')[0] : '',
        endDate: vps.endDate ? new Date(vps.endDate).toISOString().split('T')[0] : '',
        port: vps.port || '22',
        notes: vps.notes || '',
        isActive: vps.isActive !== undefined ? vps.isActive : true,
      });
    }
  }, [vps]);

  const handleChange = (e) => {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setFormData({
      ...formData,
      [e.target.name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      // Clean up empty strings
      const cleanedData = Object.keys(formData).reduce((acc, key) => {
        if (formData[key] !== '' && formData[key] !== null) {
          acc[key] = formData[key];
        }
        return acc;
      }, {});

      const data = await apiRequest(`/admin/vps/${vps._id}`, {
        method: 'PUT',
        body: JSON.stringify(cleanedData),
      });

      if (data.success) {
        setSuccess('تم تحديث خادم VPS بنجاح');
        setTimeout(() => {
          if (onUpdate) onUpdate(data.data);
        }, 1000);
      } else {
        setError(data.message || data.errors?.join(', ') || 'حدث خطأ أثناء تحديث خادم VPS');
      }
    } catch (error) {
      setError('حدث خطأ في الاتصال بالخادم');
      console.error('Error updating VPS:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card">
      <div className="card-header">
        <h2 className="card-title">تعديل خادم VPS</h2>
        <button className="btn btn-secondary btn-sm" onClick={onCancel}>
          إلغاء
        </button>
      </div>

      <form onSubmit={handleSubmit}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '1rem' }}>
          <div className="form-group">
            <label className="form-label">IP Address</label>
            <input
              type="text"
              name="ip"
              className="form-control"
              value={formData.ip}
              onChange={handleChange}
              placeholder="192.168.1.1"
            />
          </div>

          <div className="form-group">
            <label className="form-label">User</label>
            <input
              type="text"
              name="user"
              className="form-control"
              value={formData.user}
              onChange={handleChange}
              placeholder="root"
            />
          </div>

          <div className="form-group">
            <label className="form-label">Password</label>
            <input
              type="password"
              name="password"
              className="form-control"
              value={formData.password}
              onChange={handleChange}
              placeholder="اتركه فارغاً للحفاظ على القيمة الحالية"
            />
            <small style={{ color: '#666', display: 'block', marginTop: '0.25rem' }}>
              اتركه فارغاً للحفاظ على القيمة الحالية
            </small>
          </div>

          <div className="form-group">
            <label className="form-label">Port</label>
            <input
              type="text"
              name="port"
              className="form-control"
              value={formData.port}
              onChange={handleChange}
              placeholder="22"
            />
          </div>

          <div className="form-group">
            <label className="form-label">Provider</label>
            <input
              type="text"
              name="provider"
              className="form-control"
              value={formData.provider}
              onChange={handleChange}
              placeholder="DigitalOcean, AWS, etc."
            />
          </div>

          <div className="form-group">
            <label className="form-label">Provider User</label>
            <input
              type="text"
              name="providerUser"
              className="form-control"
              value={formData.providerUser}
              onChange={handleChange}
              placeholder="Provider account username"
            />
          </div>

          <div className="form-group">
            <label className="form-label">Provider Password</label>
            <input
              type="password"
              name="providerPassword"
              className="form-control"
              value={formData.providerPassword}
              onChange={handleChange}
              placeholder="اتركه فارغاً للحفاظ على القيمة الحالية"
            />
            <small style={{ color: '#666', display: 'block', marginTop: '0.25rem' }}>
              اتركه فارغاً للحفاظ على القيمة الحالية
            </small>
          </div>

          <div className="form-group">
            <label className="form-label">
              <input
                type="checkbox"
                name="isActive"
                checked={formData.isActive}
                onChange={handleChange}
                style={{ marginLeft: '0.5rem' }}
              />
              نشط
            </label>
          </div>
        </div>

        <div className="form-group">
          <label className="form-label">Start Date</label>
          <input
            type="date"
            name="startDate"
            className="form-control"
            value={formData.startDate}
            onChange={handleChange}
          />
        </div>

        <div className="form-group">
          <label className="form-label">End Date</label>
          <input
            type="date"
            name="endDate"
            className="form-control"
            value={formData.endDate}
            onChange={handleChange}
          />
        </div>

        <div className="form-group">
          <label className="form-label">Notes</label>
          <textarea
            name="notes"
            className="form-control"
            rows="3"
            value={formData.notes}
            onChange={handleChange}
            placeholder="ملاحظات إضافية..."
          />
        </div>

        {error && (
          <div className="badge badge-danger" style={{ marginBottom: '1rem', display: 'block', padding: '0.75rem' }}>
            {error}
          </div>
        )}

        {success && (
          <div className="badge badge-success" style={{ marginBottom: '1rem', display: 'block', padding: '0.75rem' }}>
            {success}
          </div>
        )}

        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end', marginTop: '2rem' }}>
          <button type="button" className="btn btn-secondary" onClick={onCancel}>
            إلغاء
          </button>
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'جاري التحديث...' : 'حفظ التغييرات'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditVPS;

